module.exports = __webpack_public_path__ + "static/media/wikisearch.cd7c2c83.png";